import { Controller } from "@hotwired/stimulus"

// Robust tooltip: appends to <body> with position:fixed, immune to overflow clipping.
// Usage: <span data-controller="tooltip" data-tooltip-content-value="Tooltip text">trigger</span>
export default class extends Controller {
  static values = { content: String }

  connect() {
    this._show = this._show.bind(this)
    this._hide = this._hide.bind(this)
    this.element.addEventListener("mouseenter", this._show)
    this.element.addEventListener("mouseleave", this._hide)
  }

  disconnect() {
    this.element.removeEventListener("mouseenter", this._show)
    this.element.removeEventListener("mouseleave", this._hide)
    this._removeTooltip()
  }

  _show() {
    if (this._tip) return

    const tip = document.createElement("div")
    tip.className = "stat-tooltip"
    tip.textContent = this.contentValue

    // Arrow
    const arrow = document.createElement("div")
    arrow.className = "stat-tooltip-arrow"
    tip.prepend(arrow)

    document.body.appendChild(tip)
    this._tip = tip

    // Position after paint so we can measure
    requestAnimationFrame(() => {
      if (!this._tip) return
      const rect = this.element.getBoundingClientRect()
      const tipRect = tip.getBoundingClientRect()

      // Center below trigger, clamp to viewport
      let left = rect.left + rect.width / 2 - tipRect.width / 2
      left = Math.max(8, Math.min(left, window.innerWidth - tipRect.width - 8))

      const top = rect.bottom + 8

      tip.style.left = `${left}px`
      tip.style.top = `${top}px`

      // Position arrow relative to trigger center
      const arrowLeft = rect.left + rect.width / 2 - left
      arrow.style.left = `${arrowLeft}px`

      tip.classList.add("is-visible")
    })
  }

  _hide() {
    this._removeTooltip()
  }

  _removeTooltip() {
    if (this._tip) {
      this._tip.remove()
      this._tip = null
    }
  }
}
